import React from 'react';

const Locator = () => {
  //please, do not remove or change id name
  return <div id="locator-container" className='locator-container'></div>;
}

export default Locator